import MarkdownComponent from 'components/shared/MarkdownComponent';
import {
  UIOfferBars,
  UIOfferWhenSchedule
} from 'interfaces/ui/ui-offer-when-schedule';
import { useState } from 'react';
import RadioButton from '../../shared/RadioButton';
import { StyledJobOfferLongText } from '../JobOfferLongText.styled';
import WhenInfographic from './WhenInfographic';
import WhenInfographicMobile from './WhenInfographicMobile';
import {
  StyledWhenSchedule,
  StyledWhenScheduleContent,
  StyledWhenScheduleExtra,
  StyledWhenScheduleSwitcher
} from './WhenSchedule.styled';

const WhenSchedule = (props: {
  schedules: UIOfferWhenSchedule[];
  migratedToMarkdown: boolean;
}) => {
  const [activeSchedule, setActiveSchedule] = useState(0);

  return (
    <StyledWhenSchedule>
      {props.schedules && props.schedules.length > 1 && (
        <StyledWhenScheduleSwitcher>
          {props.schedules.map((schedule: UIOfferWhenSchedule, i: number) => (
            <RadioButton
              key={i}
              name="scheduleSwitcher"
              id={'scheduleSwitcher' + i}
              label={
                <>
                  <strong>{schedule.name}</strong>
                </>
              }
              checked={i === activeSchedule}
              onClick={() => setActiveSchedule(i)}
            />
          ))}
        </StyledWhenScheduleSwitcher>
      )}

      <StyledWhenScheduleContent>
        {props.schedules &&
          props.schedules[activeSchedule]?.bars.map(
            (bar: UIOfferBars, i: number) => (
              <div key={i}>
                <WhenInfographic
                  ranges={bar.ranges}
                  title={bar.title}
                  subtitle={bar.subtitle}
                  caption={bar.caption}
                  inOutFlexibleMinutes={bar.inOutFlexibleMinutes}
                />
                <WhenInfographicMobile
                  ranges={bar.ranges}
                  title={bar.title}
                  subtitle={bar.subtitle}
                />
              </div>
            )
          )}
        {props.schedules[activeSchedule]?.text && (
          <StyledWhenScheduleExtra>
            {props.migratedToMarkdown ? (
              <StyledJobOfferLongText>
                <MarkdownComponent
                  content={props.schedules[activeSchedule]?.text ?? ''}
                />
              </StyledJobOfferLongText>
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: props.schedules[activeSchedule]?.text ?? ''
                }}
              ></div>
            )}
          </StyledWhenScheduleExtra>
        )}
      </StyledWhenScheduleContent>
    </StyledWhenSchedule>
  );
};

export default WhenSchedule;
